import { ProjectActions } from '@octopus-do/octopus-project-core'
import type { AppState } from '@store/types'
import { put } from 'redux-saga/effects'

import type { XmlImportModel } from '@/utils/xml'
import { buildTagIdByKey, normalizeTagTitle } from '@/utils/xml'

export function* createTagMap({
  model,
  defaultColorId,
  state,
  tagIdMap,
  projectColorByHex,
}: {
  model: XmlImportModel
  defaultColorId: string
  state: AppState
  tagIdMap: Map<string, string>
  projectColorByHex: Map<string, string>
}): Generator<any, void, any> {
  const existingTagIdByKey = buildTagIdByKey(state.manager.project.tags)

  for (const tag of model.tags) {
    const tagKey = normalizeTagTitle(tag.title)
    const existingTagId = existingTagIdByKey.get(tagKey)

    if (!tagKey) {
      continue
    }

    if (existingTagId) {
      tagIdMap.set(tag.id, existingTagId)
      continue
    }

    const colorId =
      (tag.colorHex && projectColorByHex.get(tag.colorHex)) || defaultColorId

    yield put(
      ProjectActions.tags.add({
        items: [
          {
            id: tag.id,
            title: tag.title,
            colorId,
            nodes: [],
          },
        ],
      })
    )

    existingTagIdByKey.set(tagKey, tag.id)
    tagIdMap.set(tag.id, tag.id)
  }
}
